import { SendUpgradeMailMeta, SendUpgradeMailPayload } from 'types/store/SendUpgradeMail';
import { createAsyncReducer } from 'utils/Redux';

import { sendUpgradeMailActions } from '../actions';

export default createAsyncReducer<SendUpgradeMailMeta, SendUpgradeMailPayload>(sendUpgradeMailActions);
